<template>
  <page-outline :title="$t('mandate.sepa_core_collection')">
    <template slot="pageContent">
      <b-container fluid>
        <div class="requestsList">
          <div class="mt-0">
            <div>
              <b-row class="min-w-100 justify-content-start align-items-center">
                <b-col cols="12" class="d-flex justify-content-start mt-3 mb-5">
                  <back-button class="btnFilter_2 mr-2 btn-back" :returnUrl="returnUrl"></back-button>
                </b-col>
              </b-row>
              <b-row class="text-xl-start mb-3" v-if="type !== 'dbtr'">
                <b-col xl="6" lg="9" md="12" cols="12">
                  <b-button-group class="mt-3 mt-sm-0">
                    <b-button class="px-4" :variant="tabName === 1 ? 'primary btn-selected' : ''" @click="changeTabName(1)">{{ $t('mandate.unit') }}</b-button>
                    <b-button class="px-4" :variant="tabName === 2 ? 'primary btn-selected' : ''" @click="changeTabName(2)">{{ $t('mandate.bulk') }}</b-button>
                  </b-button-group>
                </b-col>
              </b-row>

              <Unit v-if="tabName === 1"></Unit>
              <Bulk v-else-if="tabName === 2"></Bulk>
            </div>
          </div>
        </div>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import conf from '../../config/config.dev.js'
import PageOutline from '@/components/common/PageOutline.vue'
import BackButton from '@/components/common/backButton.vue'
import Unit from './FormPageUnitSDD.vue'
import Bulk from './FormPageBulkSDD.vue'


export default {
  name: 'GroupFormPage',
  components: {
    Unit,
    Bulk,
    BackButton,
    'page-outline': PageOutline,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      activateSpinner: false,
      BIC: '',
      dateBegin: '',
      dateEnd: '',
      displayFilter: false,
      filterBy: '',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      hasDefaultFilter: false,
      IBAN: '',
      identifier: '',
      idTrackAcc: '',
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      returnUrl: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      statusVerification: '',
      tabName: 1,
      technicalStatus: '',
      trackActive: '',
      TracksList: [],
      TrackType: ''
    }
  },
  created () {
    this.IdMandate = this.$route.query.IdMandate
    this.returnUrl = '/mandatedetail/' + this.IdMandate
    this.tabName = 1
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  computed: {
    type() {
      return this.$route.params.type
    }
  },
  methods: {
    changeTabName (tabName) {
      this.tabName = tabName
    }
  }
}
</script>
<style scoped>
.btn.btn-secondary {
  background: var(--actionButtonColorViolet);
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorBlue);
}
.btn.btn-back {
  background: var(--actionButtonColorBlue);
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorWhite);
}
</style>
